"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectElementsForm = exports.getElementCacheKey = exports.selectState = void 0;
/**
 * @internal
 */
exports.selectState = function (state) { return state; };
/**
 * @internal
 */
exports.getElementCacheKey = function (state, element) {
    return state.elementsForm === "uris" ? element.uri : element.title;
};
/**
 * @internal
 */
exports.selectElementsForm = function (state) { return state.elementsForm; };
//# sourceMappingURL=selectors.js.map